import { lazy, ReactNode } from "react";

export interface Route {
  path: string;
  /**
   * Screen component goes here
   */
  render: ReactNode;
  name: string;
  exact?: boolean;
}

//-----[Lazy Imports Screens]-----
const Map = lazy(() => import("screens/Map"));
const SkewT = lazy(() => import("screens/SkewT"));
const Wbgt = lazy(() => import("screens/Wbgt"));
const Hi = lazy(() => import("screens/Hi"));
const Climate = lazy(() => import("screens/Climate"));
const Weather = lazy(() => import("screens/Weather"));
//-----[Routes]-----
const routes: Route[] = [
  { name: "Map", path: "/", exact: true, render: <Map /> },
  // { name: "WBGT", path: "/WBGT", exact: true, render: <Wbgt /> },
  { name: "SkewT", path: "/profiles", exact: true, render: <SkewT /> },
  { name: "Weather", path: "/weather", exact: true, render: <Weather /> },
  { name: "Hi", path: "/hi", exact: true, render: <Hi /> },
  { name: "Climate", path: "/climate", exact: true, render: <Climate /> },
];

export default routes;
